<template>
  <div class="suggest-box">
    <transition :css="false"
                @before-enter="beforeEnterRow"
                @enter="enterRow"
                @leave="leaveRow">
      <ul v-if="show && suggests.length">
        <li v-for="(suggest, suggest_index) in suggests"
            :key="suggest_index"
            class="text-primary"
            @click="$emit('suggest:selected', suggest), show = false">
          {{ suggest.label }}
        </li>
      </ul>
    </transition>

    <div v-if="show"
         class="suggest-box-overlay"
         @click="show = false"></div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'suggestBox',
  props: {
    suggests: {}
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    beforeEnterRow (el) {
      // el.style.opacity = 0
      el.style.maxHeight = 0
    },
    enterRow (el, done) {
      gsap.to(el, {
        // opacity: 1,
        maxHeight: 135,
        delay: el.dataset.index * 0.35,
        onComplete: done
      })
    },
    leaveRow (el, done) {
      gsap.to(el, {
        // opacity: 0,
        maxHeight: 0,
        delay: el.dataset.index * 0.35,
        onComplete: done
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.suggest-box {
  overflow: hidden;

  ul {
    position: absolute;
    top: auto;
    right: 0;
    left: 0;
    z-index: 50000;
    max-height: 13.5rem;
    overflow: auto;
    background: #ffffff;
    border-radius: 0 0 .5rem .5rem;
    border: 1px solid #cecece;
    padding: 0 0.5rem;
    border-top: none;

    &::-webkit-scrollbar {
      display: block;
      border-radius: 0.5rem;
      width: 0.3rem;
      background: #222222;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      border-radius: 0.5rem;
      background: #555555;
    }

    li {
      border-top: 1px solid #cecece;
      line-height: 3rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;

      &:last-child {
        border-radius: 0 0 .5rem .5rem;
      }
    }
  }

  .suggest-box-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 49000;
    cursor: pointer;
  }
}
</style>
